module.exports = __webpack_public_path__ + "static/media/clock.9ce369b3.svg";